import { z } from 'zod';

/** ISO 4217 alphabetic currency code, e.g. `USD`. */
export const CurrencyCodeSchema = z
  .string()
  .regex(/^[A-Z]{3}$/, 'Expected an ISO 4217 alphabetic code')
  .describe('ISO 4217 currency code, e.g. USD');
/** ISO 4217 currency code. */
export type CurrencyCode = z.infer<typeof CurrencyCodeSchema>;

/**
 * Money as integer minor units plus currency (standards §1). Never a float: `z.int()` rejects
 * fractions, NaN, infinities and unsafe integers. Amounts are in the account currency,
 * provisional until Q27. Formatting happens only in the UI with `Intl.NumberFormat`.
 */
export const MoneySchema = z
  .object({
    amountMinor: z.int().describe('Signed amount in minor units (cents for USD).'),
    currency: CurrencyCodeSchema,
  })
  .describe('Money in integer minor units plus ISO 4217 currency (standards §1).');
/** Money value. */
export type Money = z.infer<typeof MoneySchema>;
